import useFeatureFlag, { FEATURE_FLAGS } from '@/utils/featureFlags';

export const useMyMoneyReimbursementFeatureFlag = () => {
  const isUseMyMoneyReimbursementEnabled = useFeatureFlag(FEATURE_FLAGS.USE_MY_MONEY_REIMBURSEMENT);
  return { isUseMyMoneyReimbursementEnabled };
};
